import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/42.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Duży rynek"
            question="Co kupujesz?"
            audio={audio}
            answers={{
                ans1: "Do karczmy pani Jasińskiej.",
            }}
            links={{
                link1: PAGES.p87,
            }}
            content={
                <div>
                    <p>
                        Zanim wychodzisz na duży rynek, słyszysz okrzyki.
                    </p>
                    <ul>
                        <li>No, kupujta: mydli, powidli, swirguski, pierduski!</li>
                        <li>Zabieraj te kurczaki, flejtuchu!</li>
                        <li>Gęęęsi sprzedam, gęsi!
                        </li>
                    </ul>
                    <p>
                        Są tu nawet koniki na biegunach. Twoją uwagę przykuwa stoisko z czarnymi robakami.
                    </p>
                    <ul>
                        <li>Pijawki, pijawki! – mówi sprzedawca. – Do upuszczania krwi.</li>
                    </ul>
                    <p>
                        Kawałek dalej widzisz stół z samowarem.
                    </p>
                    <ul>
                        <li>Buuułeczki z herbatką, buuułeczki z herbatką – krzyczy rumiana kobieta w kwiecistej sukience. Zostało ci trochę pieniędzy, które pożyczył ci Emil.</li>
                    </ul>
                </div>
            }
        />

    );
}